import {isLocal} from "./devLiveCheck.js";

//this function is kind of a hack. If youre on a page like http://localhost:3000/comicDatabase/page28
//and refresh the page, the url is the same. BUT the redux property tracking the current page is reset to 1. 
//so the pagination will be highlighting page1, while its not displayed. The content will also be showing
//the appropriate content for page 1. Even though the pagination says page 28. 
//The pagination is built depending on the url param 'page'

//so the purpose of this function is on refresh, it sets the url back to page 1, 
//making the pagination display correctly. This only happens once per launch in the App.js contructor()

//NOTE: Fir this to work, i also needed to create a redirect in the .htaccess file for a live apache server
export function routeRedirect(){
    var url = window.location.href;
    var urlPageCheck = url.substr(url.length - 5);

    if(!isLocal()){
        //console.log(urlPageCheck);
        if(url.indexOf("/comicDatabase/") !== -1 && urlPageCheck !== "page1"){
            document.location.replace("http://www.webnamehere.com/jarvis/comicDatabase/page1");
        }
        if(url.indexOf("/characterDatabase/") !== -1 && urlPageCheck !== "page1"){
            document.location.replace("http://www.webnamehere.com/jarvis/characterDatabase/page1");
        }   
    
    }else{
        //console.log(urlPageCheck);
        if(url.indexOf("/comicDatabase/") !== -1 && urlPageCheck !== "page1"){
            window.location.href = "http://localhost:3000/comicDatabase/page1";
        }
        if(url.indexOf("/characterDatabase/") !== -1 && urlPageCheck !== "page1"){
            window.location.href = "http://localhost:3000/characterDatabase/page1";
        }   
    }




}


// WEBPACK FOOTER //
// ./src/components/includes/behindTheScenes/routeRedirect.js